import React, { useState, useEffect, useContext } from 'react';
import "../Styles.css";
import "../../../ui-styles/contentHeading/contentHeading.css";
import "../../../ui-styles/profile/HzntlProfile.css";
import "../../../ui-styles/profile/HzntlProfile.css";
import "../../../ui-styles/progressbar/progressBar.css";
import "./BookAppointments.css";
import { LangCtx, PayLoadCtx, RoleCtx, SignalerCtx } from "../../../lib/context";
import currency from '../../../config/currency.json'
import { useHistory, useParams } from 'react-router-dom';
import TimeSlots from "./components/TimeSlots";
import VisitReason from "./components/VisitReason";
import FileUploads from "./components/FileUploads";
import Confirmation from "./components/Confirmation";
import BookingStatus from "./components/BookingStatus";
import { getUserDetails } from "../../../actions/users";
import { getDoctorSchedules, createAppointment, getAxios } from "../../../actions/appointment";
import { getStipeDetials } from "../../../actions/users";
import { getDisableDates } from "../../../actions/schedule";
import DateFnsUtils from '@date-io/date-fns';
import { KeyboardDatePicker, MuiPickersUtilsProvider, } from '@material-ui/pickers';
import Loader from "../../../lib/ui/loader/Loader";

// import PlansList from "../../../config/plans.json";
import { toast } from 'react-toastify';
// import { subscribePlan } from '../../../actions/payment';
import Button from '../../../lib/ui/buttons/Button';
import { getExperience } from '../../../lib/functions';
// import config from "../../../config.json";

import "../../../ui-styles/list/contactInfoList.css";
import "../../../ui-styles/list/CardsList.css";
// import { Link } from 'react-router-dom';
//import { LangCtx } from "../../../../lib/context";

// import { getappointment } from '../../../actions/appointment';
// import { getDegree, getDepartmentList, getSpecialization } from '../../../actions/configuration';
// import currencySymbols from '../../../locale/currencyCodes.json'
import { useSelector } from 'react-redux';

const BookAppointment = (props) => {
    const history = useHistory();
    const { dId, pId } = useParams();
    const [defaultCountry, setDefaultCountry] = useState(null);
    const { l, currencyCode } = useContext(LangCtx);
    const { role } = useContext(RoleCtx);
    const { payload } = useContext(PayLoadCtx);
    const { signaler } = useContext(SignalerCtx);
    const selected = props?.location?.state?.date ? new Date(props.location.state.date) : new Date();
    const [date, changeDate] = useState(selected);
    const [schedules, setSchedules] = useState([]);
    const [sId, setSID] = useState(null);
    const [active, setActive] = useState("TS");
    const [doctorData, setDoctor] = useState(null);
    const [loading, setLoading] = useState(true);
    const [formData, setFormData] = useState({});
    const [disableDates, setDisableDates] = useState([]);
    const [keys, setKeys] = useState({ serverstripekey: process.env.REACT_APP_serverstripekey, clientstripekey: process.env.REACT_APP_clientstripekey });

    // const [windowObj, setwindowObj] = useState();

    const [stripeRes, setStripeRes] = useState();

    const [paymentButton, setPayButton] = useState(false);
    const [payUrl, setPayUrl] = useState("");
    // const [appData, setAppData] = useState({});
    const [invitedUserEmail,setInvitedUserEmail] = useState('');
    // const [invitedUserEmail,setInvitedUserEmail] = useState([]);
    // const [rates, setRates] = useState(null)
    const rates = useSelector((state) => state?.inclinic?.rates);
    const location = localStorage.getItem('country');

    useEffect(() => {
        getUserDetails(dId).then(res => {
            if(res.status){
                const countryOptions = currency.map((country) => ({
                    value: country.countryCode,
                    label: `${country.country}`,
                    countryCode: country.countryCode,
                    currencyCode: country.code,
                    currencySymbol: country.symbol || '',
                  }));
                const selectedCountry = countryOptions.find(country => country.countryCode === res.data.currency);
                setDefaultCountry(selectedCountry)
                setDoctor(res.data)
            }
        }).catch(err => {
            console.log("err ==== ", err);
            setDoctor(null);
        });
        getDoctorSchedules(dId).then(res => {
            if (res && res.status) {
                setSchedules([...res.data]);
            } else {
                setSchedules([]);
            }
        }).catch(err => {
            console.log("err ==== ", err);
            setSchedules([]);
        });
        getDisableDates(dId).then(res => {
            if (res && res.status && res.data && res.data && res.data.dates && res.data.dates.length > 0) {
                setDisableDates([...res.data.dates]);
            } else {
                setDisableDates([]);
            }
        }).catch(err => {
            console.log("error", err);
        });;
        if (process.env.REACT_APP_payment === "true") {
            let id = role === "C" ? payload.userId : payload.clinicId;
            getStipeDetials(id).then((res) => {
                if (res.data) {
                    setKeys({ serverstripekey: res.data.serverstripekey, clientstripekey: res.data.clientstripekey });
                } else {
                    setKeys({ serverstripekey: process.env.REACT_APP_serverstripekey, clientstripekey: process.env.REACT_APP_clientstripekey });
                }
            }).catch(err => {
                console.log("error ==== ", err);
                setKeys({ serverstripekey: process.env.REACT_APP_serverstripekey, clientstripekey: process.env.REACT_APP_clientstripekey });
            });
        }
    }, []);

    const handleSelectDate = (e) => {
        const formattedDate = `${e.getFullYear()}-${e.getMonth() + 1}-${e.getDate()}`;
        changeDate(new Date(formattedDate));
        setActive("TS");
    };

    const handleInvitedEmail = (email) => {

        setInvitedUserEmail(email);
        // const [username, domain] = email.split('@');
        // const existingIndex = invitedUserEmail.findIndex(email => email.split('@')[0] === username);
        // if (existingIndex !== -1) {
        //     const updatedEmails = [...invitedUserEmail];
        //     updatedEmails[existingIndex] = email;
        //     setInvitedUserEmail(updatedEmails);
        //   } else {
        //     // Otherwise, add the new email to the state
        //     setInvitedUserEmail([...invitedUserEmail,email]);
        //   }
      };


    // useEffect(()=>{

    //     if (windowObj && windowObj.closed){
    //         setLoading(false)
    //     }

    // },[windowObj])

    useEffect(() => {
        setLoading(true);
        let _d = new Date(date);
        let day = Number(_d.getDay());
        let _dd = new Date(date);
        _dd.setHours(0, 0, 0, 0);
        let _s = schedules.filter(sch => sch.from <= _d.valueOf() && sch.to >= _d.valueOf() && sch.days.indexOf(day) > -1);
        if (_s && _s.length > 0) {
            if (disableDates.indexOf(_dd.valueOf()) <= -1) {
                setLoading(false);
                setSID(_s[0].scheduleId);
            } else {
                setLoading(false);
                setSID(null);
            }
        } else {
            setLoading(false);
            setSID(null);
        }
    }, [date, schedules, disableDates]);

    const handleClick = () => {
        role === "C" ? history.push(`/doctor-schedule/${pId}`) : history.push("/doctor-booking");
    };

    const handleActive = () => {
        setActive(prevState => !prevState);
    };

    const delay = (n) => {
        return new Promise(done => {
            setTimeout(() => {
                done();
            }, n);
        });
    };

    const makeDelay = async (n) => {
        await delay(n);
    };

    const handleData = (data, next) => {
        let _f = { ...formData, ...data };
        setFormData(_f);
        setActive(next);
    };

    const handleBook = () => {
        if (!loading) {
            setLoading(true);

            let form = { ...formData };
            form["doctorId"] = dId;
            form["patientId"] = role === "C" ? pId : payload.userId; // if clinic pass patientID
            form["clinicId"] = role === "C" ? payload.userId : payload.clinicId; // if clinic pass self id
            form["adminId"] = payload.adminId;
            // setFormData(form);
            //setSubmitted(true)
            // form["clinicData"] = {};
            // return;

        }
    };

    const makePayment = () => {

        //let form = { ...formData };

        if (role === "C") {

            history.push({
                pathname: '/confirmclc-payment',

                state: { "formData": formData, apptId: stripeRes, "doctorData": doctorData }
            });

        }

        else {

            history.push({
                pathname: '/confirm-payment',

                state: { "formData": formData, apptId: stripeRes, "doctorData": doctorData }
            });
        }

    };


    const onClose = () => {
        setLoading(false);
    };

   

    const handleFreeAppointment = () => {
        if (!loading) {
            setLoading(true);
            let data = { ...formData };
            data["doctorId"] = dId;
            data["patientId"] = role === "C" ? pId : payload.userId; // if clinic pass patientID
            data["clinicId"] = role === "C" ? payload.userId : payload.clinicId; // if clinic pass self id
            data["adminId"] = payload?.adminId;
            invitedUserEmail && invitedUserEmail !== '' && (data["invitedEmail"] = invitedUserEmail);
            if (doctorData && doctorData.currency) {
                data["currency"] = doctorData.currency.toLowerCase();
            }
            else {
                data["currency"] = "inr";
            }
            data['cents']=0;
            createAppointment(data).then((res) => {
                if (res.status) {
                    toast.success(l.appointment_booked_successfully, {
                        position: toast.POSITION.TOP_RIGHT
                    });
                    // setAppData(data);
                    setActive('BS');
                } else {
                }
                setLoading(false);
            }).catch(err => {
                console.log("err === ", err);
                setLoading(false);
                if (err?.response?.data?.errorCode && err.response.data.errorCode === 402) {
                    toast.error(err.response.data.error, {
                        position: toast.POSITION.TOP_RIGHT
                    });
                    history.push("/payment-failure");
                } else {
                    let msg = err?.response?.data?.error ? err.response.data.error : "Failed to book the appointment, try again!";
                    toast.error(msg, {
                        position: toast.POSITION.TOP_RIGHT
                    });


                }

            });
        }
    };

    const renderConsultationFee = () => {
        if (!doctorData?.paymentType || doctorData?.paymentType === "free") return null;
        
        const matchingFee = doctorData?.newconsultationFee?.find(
            (fee) => String(fee.currency).toUpperCase() === String(currencyCode).toUpperCase()
        );

        if (matchingFee) {
            return (
                <span className="profleSDrkTxt">
                    <strong>
                        {`${matchingFee.currency} ${matchingFee.amount}`}
                    </strong>{" "}
                    {l.consult_fee}
                </span>
            );
        } else if (doctorData) {
            return (
                <span className="profleSDrkTxt">
                    <strong>
                    {`${doctorData?.currency} ${
                        doctorData.consultationFee
                            ? Number(doctorData.consultationFee)
                            : 0
                    }`}
                    </strong>{" "}
                    {l.consult_fee}
                </span>
            );
        } else {
            return null
        }
    };
    
    

    const onToken = async (token) => {
        if (!loading) {
            setLoading(true);
            let matchingFee
            let form = { ...formData };
            form["doctorId"] = dId;
            form["patientId"] = role === "C" ? pId : payload.userId; // if clinic pass patientID
            form["clinicId"] = role === "C" ? payload.userId : payload.clinicId; // if clinic pass self id
            form["adminId"] = payload.adminId;
            if (process.env.REACT_APP_payment === "true") {
                form['token'] = token;
                form['serverstripekey'] = keys.serverstripekey;
            }
            if(defaultCountry.currencyCode !== currencyCode){
                matchingFee = doctorData?.newconsultationFee?.find(
                    (fee) => String(fee.currency).toUpperCase() === String(currencyCode).toUpperCase()
                );
            }

            if (doctorData && doctorData.currency) {
                form["currency"] = matchingFee ? matchingFee.currency : defaultCountry.currencyCode
                form["fee"] = matchingFee ? matchingFee.amount : doctorData.consultationFee ? Number(doctorData.consultationFee) : 0
            }

            let curr = form.currency.toLowerCase()
            if (curr !== 'usd') {
                await getAxios(curr).then((res) => {
                    let result = res.data[curr]
                    form["cents"] = (result['usd'] * form.fee) * 100
                }).catch((err) => console.log(err))
            } else if (curr === 'usd') {
                form["cents"] = form.fee * 100
            }
            invitedUserEmail && invitedUserEmail !== '' && (form["invitedEmail"] = invitedUserEmail);
            form["cents"] = form?.cents > 0 ? form?.cents : 0;
            createAppointment(form).then(res => {
                ///////////////////////nextAction///
                if (res.data.data.next_action && res.data.data.next_action.use_stripe_sdk) {
                    toast.success("You will be redirected to payment authentication window", {
                        position: toast.POSITION.TOP_RIGHT
                    });

                    setPayUrl(res.data.data.next_action.use_stripe_sdk.stripe_js);
                    setPayButton(true);

                    setFormData(form);

                    setStripeRes(res.data.data.metadata.appointmentId);
                    
                    //setwindowObj( window.open(res.data.data.next_action.use_stripe_sdk.stripe_js))



                    // history.push({
                    //     pathname: '/confirm-payment',

                    //     state: { "formData": form, apptId:res.data.data.metadata.appointmentId, "doctorData":doctorData }
                    // });

                    // while(!paywin.closed){
                    //    console.log("")
                    // }

                    //    getappointment(res.appointmentId).then((appt)=>{
                    //        if (appt.status ){

                    //         setLoading(true);


                    //         if(appt.data.paymentStatus==="paid" || appt.data.paymentStatus==="initiated" ){
                    //         toast.success("Appointment booked successfully", {
                    //             position: toast.POSITION.TOP_RIGHT
                    //         })
                    //     }else{

                    //         toast.error("Appointment booking failed !", {
                    //             position: toast.POSITION.TOP_RIGHT
                    //         })

                    //     }     setActive("BS")

                    //         if (signaler) {
                    //             signaler.renderAppoints(dId, "PENDLIST");
                    //         }




                    //        }
                    //    })

                    // while(!paywin.closed || windowTimer===12){

                    //     console.log(windowTimer)

                    //      makeDelay.then(()=>{

                    //         windowTimer++
                    //      }

                    //      )


                    // }
                }
                setLoading(false);
                if (res.status && !(res.data.data.next_action)) {
                    setActive("BS");
                    toast.success(l.appointment_booked_successfully, {
                        position: toast.POSITION.TOP_RIGHT
                    });
                    if (signaler) {
                        signaler.renderAppoints(dId, "PENDLIST");
                    }
                    // form["appointmentId"] = res.data;
                    // setFormData(form);
                    // setActive("BS")
                }
            }).catch(err => {
                console.log("err === ", err);
                setLoading(false);
                if (err?.response?.data?.errorCode && err.response.data.errorCode === 402) {
                    toast.error(err.response.data.error, {
                        position: toast.POSITION.TOP_RIGHT
                    });
                    history.push("/payment-failure");
                } else {
                    let msg = err?.response?.data?.error ? err.response.data.error : "Failed to book the appointment, try again!";
                    toast.error(msg, {
                        position: toast.POSITION.TOP_RIGHT
                    });


                }

            });
        }
    };

    return (

        <div className="baseContainer">

            {paymentButton ?

                <div className="baColBlock alignCenter">

                    <div className="contactList ">
                        <div className="contactDtls alignCenter">
                            <div className="pushLinkBox">

                                <a href={payUrl} target="_blank" className="linkTxt linkTxtSm" rel="noopener noreferrer">
                                    <Button label={l.clk_to_comp_pay}
                                        type='primary'
                                        size='md'
                                        fullWidth="fullWidth"
                                        onClick={makePayment}
                                    />
                                </a>
                            </div>
                        </div>
                    </div>


                </div> :
                <>
                    <div className="hdngTopCol colBlock">
                        <div className="hdngTopBox etcPdng">
                            <h2 className="topHdngTxt">{l.book_apptmnt}</h2>
                        </div>
                        <div className="topBackRow" onClick={handleClick}>
                            <span className="topBackLink">{l.bck_prev}</span>
                        </div>
                        {doctorData && <div className="hztlProfleRow">
                            <div className="hztlAvatar Md">
                                <img src={doctorData.profileImage && doctorData.profileImage.url ? doctorData.profileImage.url : "/images/icons/doctor-default.png"} alt="avatar" />
                            </div>
                            <div className="hztlProfileInfo">
                                <span className="profleLTxt primaryTxtColor">{`Dr. ${doctorData.firstName} ${doctorData.lastName ? doctorData.lastName : ''}`}</span>
                                <span className="profleSTxt">{doctorData.qualification ? doctorData.qualification : ""}
                                    {doctorData.department ? `(${doctorData.department})` : ''}
                                    {doctorData.serviceStartDate ? `- ${getExperience(new Date(doctorData.serviceStartDate))}` : ''}</span>
                                <span className="profleSTxt">{doctorData.speciality ? doctorData.speciality : ''}</span>
                                {doctorData?.paymentType === "free" && <span className="profleSDrkTxt">Consultation Free</span>}
                                {doctorData?.paymentType !== "free" && (
                                    <>
                                    {renderConsultationFee()}
                                        {/* {
                                            (doctorData.currency && doctorData.currency === "INR") &&

                                            <span className="profleSDrkTxt">
                                                {currencyCode && role === "P" ? <>
                                                    <strong>{currencySymbols[currencyCode].symbol} {doctorData.consultationFee ? Math.round(doctorData.consultationFee / (rates ? rates["inr"] : 1)) : ''}</strong> {doctorData.consultationFee ? l.consult_fee : ''}
                                                </> : <>
                                                    <strong>&#8377;{doctorData.consultationFee ? doctorData.consultationFee : ''}</strong> {doctorData.consultationFee ? l.consult_fee : ''}
                                                </>
                                                }
                                            </span>
                                        }

                                        {
                                            (doctorData.currency && doctorData.currency === "USD") &&

                                            <span className="profleSDrkTxt">
                                                {currencyCode && role === "P" ? <>
                                                    <strong>{currencySymbols[currencyCode].symbol} {doctorData.consultationFee ? Math.round(doctorData.consultationFee / (rates ? rates["usd"] : 1)) : ''}</strong> {l.consult_fee}
                                                </> :
                                                    <>
                                                        <strong>${doctorData.consultationFee ? doctorData.consultationFee : ''}</strong> {doctorData.consultationFee ? l.consult_fee : ''}
                                                    </>
                                                }
                                            </span>
                                        }
                                        {
                                            (doctorData.currency && doctorData.currency === "AED") &&

                                            <span className="profleSDrkTxt">
                                                {currencyCode && role === "P" ? <>
                                                    <strong>{currencySymbols[currencyCode].symbol} {doctorData.consultationFee ? Math.round(doctorData.consultationFee / (rates ? rates["aed"] : 1)) : ''}</strong> {l.consult_fee}
                                                </> : <>
                                                    <strong>&#1583;.&#1573;{doctorData.consultationFee ? doctorData.consultationFee : ''}</strong> {doctorData.consultationFee ? l.consult_fee : ''}
                                                </>
                                                }
                                            </span>
                                        } */}

                                    </>
                                )}
                            </div>
                        </div>}
                    </div>
                    <div className="calanderBox">
                        {/* calander falls here... */}
                        <div className="calanderView">
                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                <KeyboardDatePicker
                                    autoOk
                                    orientation="portrait"
                                    variant="static"
                                    openTo="date"
                                    value={date}
                                    disablePast={true}
                                    onChange={(e) => { handleSelectDate(e); }}
                                    minDate={new Date()}
                                />
                            </MuiPickersUtilsProvider>
                        </div>
                        <div className="baseRowWrapper">
                            {active === "TS" ?
                                loading ?
                                    <Loader />
                                    : <TimeSlots active={active} handleNext={handleData} id={sId} selDate={date} doctorId={doctorData && doctorData.userId ? doctorData.userId : null} formData={formData} />
                                : null}
                            {active === "VR" &&
                                <VisitReason active={active} handleNext={handleData} formData={formData} />
                            }
                            {active === "FU" &&
                                <FileUploads active={active} handleNext={handleData} formData={formData} />
                            }
                            {active === "CF" ?
                                loading ?
                                    <Loader />
                                    : <Confirmation active={active} docData={doctorData} currency={defaultCountry?.currencyCode ? defaultCountry.currencyCode : "INR"} keys={keys} handleConfirm={onToken} handleNext={handleData} onClose={onClose} handleFreeAppointment={handleFreeAppointment} handleInvitedEmail={handleInvitedEmail} />
                                : null}
                            {active === "BS" &&
                                <BookingStatus active={active} formData={formData} doctorData={doctorData} />
                            }

                        </div>
                    </div>

                </>
            }
        </div>



    );
};
export default BookAppointment;